/**
 * The browser's best guess at which currency it should be quoted in.
 *
 * This is only a hint. The server decides what a buyer is actually charged and
 * ignores this entirely unless TRUST_CLIENT_CURRENCY_HINT is enabled — see
 * backend/src/config/pricing.js. Every call that starts a checkout must send the
 * same hint the pricing request used, or the price shown and the price charged
 * can disagree when that flag is on.
 */
export const currencyHint = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    return tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta' ? 'INR' : '';
  } catch {
    return '';
  }
};

export default currencyHint;
